(() => {
  'use strict';

  const CONTEXT_KEY = 'fitobotanic-route-context-v1';

  document.querySelectorAll('[data-fb-protocol-objectives]').forEach((section) => {
    let objective = '';

    try {
      objective = JSON.parse(window.sessionStorage.getItem(CONTEXT_KEY))?.objectiveKey || '';
    } catch (_error) {
      // La sección mantiene el orden contextual del protocolo si no hay almacenamiento disponible.
    }

    if (!objective) return;

    section.querySelectorAll('[data-fb-objective-card]').forEach((card) => {
      const isCurrent = card.dataset.fbObjectiveCard === objective;
      card.classList.toggle('is-current', isCurrent);
      if (isCurrent) card.setAttribute('aria-current', 'true');
      else card.removeAttribute('aria-current');
    });
  });
})();
